import { Component, Input, OnInit } from '@angular/core';
import { Status } from '@shared-features/enums/shared-enums.enum';

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss'],
})
export class StatusLabelComponent implements OnInit {

  @Input() value: Status | 'Busy' | 'Free' | 'NotReady';
  status = Status;

  constructor() {}

  ngOnInit(): void {}
}
